<template>
  <div
    class="col-span-1 border rounded-xl bg-indigo-200 shadow-xl px-9 py-11 flex flex-col hover:border-2 hover:shadow-2xl"
    :class="`border-${colorTheme(name)}-600 bg-${colorTheme(name)}-100`"
  >
    <SubscriptionCardHeader
      :name="name"
      :description="description"
    />


    <SubscriptionPrice
      v-if="false"
      :price="price"
    />
    <div class="my-7.5"></div>

    <!-- BEGIN Cette offre comprend... -->
    <SubscriptionDetails
      :details="details"
      class="mb-9"
    />
    <!-- END Cette offre comprend... -->


    <SelectSubscription
      :name="name"
      :is-current="isCurrent"
    />
  </div>
</template>
<script>
import SubscriptionDetails from './SubscriptionDetails.vue';
import SubscriptionPrice from './SubscriptionPrice.vue';
import SelectSubscription from './SelectSubscription.vue';
import SubscriptionCardHeader from './SubscriptionCardHeader.vue';
import colorTheme from './colorTheme';

export default {
  methods: {colorTheme},
  props: {
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    details: {
      type: Array,
      required: true
    },
    price: {
      type: Number,
      required: true
    },
    isCurrent: {
      type: Boolean,
      required: true
    }
  },

  components: {
    SubscriptionCardHeader,
    SelectSubscription,
    SubscriptionPrice,
    SubscriptionDetails,
  },
};
</script>